import React from "react";
import { IconProps } from "../icon";

export const ArrowNarrowDownRightIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 6l12 12m0 0v-8m0 8h-8" />
  </svg>
);
